import ui from "./ui/index";
import props from "./prop-types/index";
import globals from "./globals/index";
import selectors from "./selectors/index";
import api from "./api/index";
import models from "./models/index";
import util from "./util/index";
import middleware from "./middleware";

const common = {
  ui,
  props,
  globals,
  selectors,
  api,
  models,
  util,
  middleware
};

export default common;
